module.exports = __webpack_public_path__ + "img/5.73630bf9.jpg";